export default "__VITE_ASSET__2T6ANmTR__"